import React from "react";
import PropTypes from "prop-types";
import withTranslation from "../../../translation";
import styles from "./index.css";
import Price from "../../../Price";
import GermanVATIncluded from "./GermanVATIncluded";

const SubTotal = ({ value, formatTranslation }) => {
  const price = value && value.toString();

  return (
    <div className={styles.subTotalContainer}>
      <h1>{formatTranslation("MiniBag.SubTotal")}</h1>
      <div data-test-id="miniBagSubTotal">
        <Price value={price} />
        <small className={styles.germanVATInc}>
          <GermanVATIncluded />
        </small>
      </div>
    </div>
  );
};

SubTotal.defaultProps = {
  value: null
};

SubTotal.propTypes = {
  formatTranslation: PropTypes.func.isRequired,
  value: PropTypes.number
};

export default withTranslation(SubTotal);



// WEBPACK FOOTER //
// ./template/components/MiniBag/Footer/SubTotal/SubTotal.js